const replaceURLs = (content) => {
  if (!content) return

  let urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g
  return content.replace(urlRegex, (url) => {
    let hyperlink = url
    if (!hyperlink.match('^https?://')) {
      hyperlink = 'http://' + hyperlink
    }
    return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url + '</a>'
  })
}

export default replaceURLs

export const changePathName = (lang, history, pathname) => {
  const languageRegex = /(en|zh-CN|zh-HK)/
  const match = pathname.match(languageRegex)
  if (match && match[0] !== lang) {
    history.replace(pathname.replace(languageRegex, lang))
  } else if (!match) {
    history.replace(pathname.replace('/health-platform', `/health-platform/${lang}`))
  }
}
